import {createApi} from '@reduxjs/toolkit/query/react'
import {BookingRequestWithPsd2} from 'booking/types/BookingRequest'
import {BookingData} from 'booking/types/BookingData'
import {LinkType} from '../../types/Link'
import {BookingCreationResponse} from 'booking/types/BookingCreationResponse'
import {BookingFinalizationResponse} from 'booking/types/BookingFinalizationResponse'
import {axiosBaseQuery} from '../../../utils/network/axiosBaseQuery'

export const BOOKING_REQUEST_ID_HEADER = 'x-booking-request-id'
export const API_KEY_HEADER = 'x-Api-Key'
export const REQUEST_ID_HEADER = 'x-Request-Id'

export interface PostBookingRequest {
  link: LinkType
  payload: BookingRequestWithPsd2
  httpRequestId: string
  bookingRequestId: string
  profile: string
  headers?: {
    Accept: 'application/json'
    'X-Client-User-Agent': string
  }
}

export interface PutBookingRequest {
  link: LinkType
  payload: {
    sessionId: string
  }
  httpRequestId: string
  bookingRequestId: string
  profile: string
  headers?: {
    Accept: 'application/json'
    'X-Client-User-Agent': string
  }
}

export interface GetBookingByIdRequest {
  headers: Record<string, string>
  url: string
  bookingId: string
  deviceType: 'desktop' | 'mobile'
  locale: string
}

export const bookApi = createApi({
  reducerPath: 'bookApi',
  baseQuery: axiosBaseQuery({
    baseUrl: ''
  }),
  endpoints: builder => ({
    getBookingById: builder.query<BookingData, GetBookingByIdRequest>({
      query: ({bookingId, deviceType, locale, url, headers}) => ({
        url: `${url}bookings/${bookingId}`,
        params: {
          deviceType,
          locale
        },
        headers
      })
    }),
    createBooking: builder.mutation<
      BookingCreationResponse,
      PostBookingRequest
    >({
      query: ({
        link,
        payload,
        profile,
        httpRequestId,
        bookingRequestId,
        headers
      }) => ({
        url: link.href,
        method: link.method,
        data: payload,
        headers: {
          ...headers,
          [BOOKING_REQUEST_ID_HEADER]: bookingRequestId,
          [API_KEY_HEADER]: profile,
          [REQUEST_ID_HEADER]: httpRequestId
        }
      })
    }),
    bookingFinalization: builder.mutation<
      BookingFinalizationResponse,
      PutBookingRequest
    >({
      query: ({
        link,
        profile,
        httpRequestId,
        payload,
        bookingRequestId,
        headers
      }) => ({
        url: link.href,
        method: link.method,
        body: payload,
        headers: {
          ...headers,
          [BOOKING_REQUEST_ID_HEADER]: bookingRequestId,
          [API_KEY_HEADER]: profile,
          [REQUEST_ID_HEADER]: httpRequestId
        }
      })
    })
  })
})

export const {
  useGetBookingByIdQuery,
  useCreateBookingMutation,
  useBookingFinalizationMutation
} = bookApi
